import React from "react";
import {twMerge} from 'tailwind-merge'

type ChipProps = {
    value: string;
    slug: string;
    className?: string;
    selected?: boolean;
    selectedClassName?: string;
    onClick?: (event?: React.MouseEvent<HTMLSpanElement | HTMLAnchorElement>) => void;
    href?: string;
    title?: string;
};

export function Chip(props: ChipProps) {
    const className = twMerge(
        "px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer whitespace-nowrap inline-block m-1",
        "max-w-[200px] overflow-hidden overflow-ellipsis",
        "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-100",
        "hover:bg-blue-500 hover:text-white dark:hover:bg-blue-600 dark:hover:text-gray-100",
        props.selected && (props.selectedClassName ?? 'bg-blue-500 text-white dark:bg-blue-600 dark:text-gray-100 hover:bg-blue-600 dark:hover:bg-blue-700'),
        props.className
    );
    const title = props.title ?? (props.selected
        ? `Remove ${props.value} filter`
        : props.href
            ? `View ${props.value}`
            : `Add ${props.value} filter`);

    if (props.href) {
        return (
            <a
                className={className}
                href={props.href}
                onClick={(event) => props.onClick?.(event)}
                title={title}
            >
                {props.value}
            </a>
        );
    }

    return (
        <span
            className={className}
            onClick={(event) => props.onClick?.(event)}
            title={title}
        >
            {props.value}
        </span>
    );
}
